import type {
  Node2d,
  Node2dExtracted,
  Edge2d,
  NodeMap,
  Edge2dExtracted,
  EdgeMap,
} from "."

export const extractNode = (
  node: Node2d,
  nodeId: string,
  edgeIds: string[],
): Node2dExtracted => ({
  ...node,
  id: nodeId,
  edgeIds: edgeIds.filter((id) => id.includes(nodeId)),
})

export const extractEdge = (
  edge: Edge2d,
  edgeId: string,
  ExtractedPoints: NodeMap,
): Edge2dExtracted => {
  const p1 = ExtractedPoints.get(edge.node1id)
  const p2 = ExtractedPoints.get(edge.node2id)
  if (!p1) throw new Error(`extract ${edgeId}: node "${edge.node1id}" not found`)
  if (!p2) throw new Error(`extract ${edgeId}: node "${edge.node2id}" not found`)

  return {
    ...edge,
    id: edgeId,
    p1,
    p2,
  }
}

export type ExtractMeshOptions = {
  nodeIds: string[]
  edgeIds: string[]
  getNode: (id: string) => Node2d
  getEdge: (id: string) => Edge2d
}

export type MeshExtracted = {
  nodes: NodeMap
  edges: EdgeMap
}

export const extractMeshFromStore = ({
  nodeIds,
  edgeIds,
  getNode,
  getEdge,
}: ExtractMeshOptions): MeshExtracted => {
  const nodes: NodeMap = new Map()
  const edges: EdgeMap = new Map()
  nodeIds.forEach((id) => {
    const node = getNode(id)
    const extractedNode = extractNode(node, id, edgeIds)
    nodes.set(id, extractedNode)
  })
  edgeIds.forEach((id) => {
    const edge = getEdge(id)
    let extractedEdge: Edge2dExtracted | null
    try {
      extractedEdge = extractEdge(edge, id, nodes)
    } catch (e) {
      console.log(`extractMeshFromStore: edge "${id}"`)
      extractedEdge = null
    }
    edges.set(id, extractedEdge)
  })

  return { nodes, edges }
}
